import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import usePostRequest from '../../../hooks/usePostRequest';
import { isHttpStatusSuccess } from '../../../Utils/utils';

export const MenuButtonOptionsGenerateFacture = ({ facture,refreshFactures }) => {
    MenuButtonOptionsGenerateFacture.propTypes = {
        facture: PropTypes.any,
        refreshFactures: PropTypes.func,
    };
    const { postData } = usePostRequest();
    const [anchorEl, setAnchorEl] = useState(null);
    const { i18n } = useTranslation();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeStatuFacture_X_ToGenere = async () => {
        const response1 = await postData({ url: '/facture/changeStatuFacture_X_ToGenere' ,
            payload: {[facture?.isCraOrCraX]: facture?.[facture?.isCraOrCraX]?._id} });
        // console.log(response1);
        if(isHttpStatusSuccess(response1.responseStatus)){
            refreshFactures();
            handleClose();
        }
    };

    return (
        <React.Fragment key={facture?.id} >
            {
                (facture?.Statut == 'proformat') &&
                <div>

                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <MoreVert />
                    </IconButton>

                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem
                            onClick={() => {
                                handleClose();
                                Swal.fire({
                                    html: `<p>${i18n.t('Êtes-vous sûr de vouloir générer cette facture ?')}</p>`,//+`${facture?.Statut}`,
                                    confirmButtonColor: '#5CC889',
                                    cancelButtonColor: '#88898f',
                                    cancelButtonText: 'Annuler',
                                    confirmButtonText: 'Oui',
                                    showCancelButton: true,
                                    customClass: {
                                        cancelButton: 'my-cancel-button-class'
                                    },
                                    //confirmButtonText: 'Prestation complémentaire',
                                    //cancelButtonText: 'Prestation normale',
                                    // showCloseButton: true
                                }).then((result) => {
                                    console.log(result);
                                    if (result.isConfirmed) {
                                        changeStatuFacture_X_ToGenere();
                                    }
                                    if (result.isDismissed) {
                                        handleClose();
                                    }
                                });
                            }}
                        >
                            {i18n.t('Générer')}
                        </MenuItem>
                    </Menu>
                </div>
            }

        </React.Fragment>);
};